module.exports = __webpack_public_path__ + "img/project9_8.png.0e407bc7.webp";